import { faPencil, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, ClickAwayListener, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";
import TableSingleSelectBox from "../SearchSelectBox/TableSingleSelectBox";
import { useDispatch, useSelector } from "react-redux";
import { deleteInterviewer, getClubReviewsInfo, syncInterviewers } from "../../api/evaluation";
import { setInterviewers } from "../../redux/reducers/evaluation";
import InterviewTeamSelectBox from "../InterviewTeamSelectBox";
import { AvatarAndName } from "../AvatarAndName";
import { baseUrl } from "../../api/config";
import { colors } from "../../common/pallette/colors";

const DataPreview = (props:any) => {
    const { label, data } = props;
    const [isAdd, setIsAdd] = useState(false);
    const interviewTeams = useSelector((state:any) => state.evaluation.interviewTeams);
    const interviewers = useSelector((state:any) => state.evaluation.interviewers);
    const clubDetails = useSelector((state:any) => state.clubDetails);
    const dispatch = useDispatch();    
    const [showText, setShowText] = useState('Show more');
    const [tempData, setTempData] = useState(interviewers && interviewers?.length > 3 ? interviewers.slice(0,3) : interviewers);

    const updateInterviewUsers = async (updatedUser:any, currentData:any) => {
      if (!updatedUser) {
        if (currentData && currentData?.id) {
          const response = await deleteInterviewer(currentData?.id);
          const tempArr = interviewers.filter((item:any) => currentData.id != item.id);
          dispatch(setInterviewers(tempArr));
          setTempData(tempArr);
        }
      } else {
        const tempUpdatedUsers:any = [...interviewers, updatedUser];
        dispatch(setInterviewers(tempUpdatedUsers));
        const reviewData = await getClubReviewsInfo({clubId: clubDetails?.id});
        const response = await syncInterviewers({ onSiteReviewId: reviewData?.onSiteReviewId, user: updatedUser });
        const sortedInterviewers = response.map((item:any) => {
          if (item.displayName == null) {
            const tempObj = interviewTeams.find((d:any) => d.id == item.userId);
            if (tempObj) {
              return {...item, 
                      displayName: tempObj.displayName, 
                      roleName: tempObj.roleName, 
                      avatarPath: tempObj.avatarPath ? tempObj.avatarPath : ''};
            } else {
              return {...item, displayName: 'No Name', roleName: 'No Roles', avatarPath: ''};
            }
          } return {...item, roleName: ''};
        })
        dispatch(setInterviewers(sortedInterviewers));
        setTempData(sortedInterviewers);
      }
    }

    const manageNullData = () => {
      if(isAdd) {
        const tempArr = interviewers.filter((item:any) => !(item.displayName == null && item.userId == null));
        dispatch(setInterviewers(tempArr));
      }
    }

    const manageShowClick = () => {
      if(showText == 'Show more') {
        setTempData(interviewers);
        setShowText('Show less');
      } else {
        setTempData(interviewers && interviewers?.length > 3 ? interviewers.slice(0,3) : interviewers);
        setShowText('Show more');
      }
    }

    return (
      <ClickAwayListener onClickAway={() => {manageNullData(); setIsAdd(false);}}>
        <Box sx={{ display: "flex" }}>
          <Typography className="mtbAuto mr5 fs13 fw800">{label}</Typography>
          <Box sx={{ display: 'grid', gridTemplateColumns: 'auto auto', gridTemplateRows: 'auto auto', textAlign: 'left' }}>
            {
                tempData && tempData.map((d:any, index:any) => {
                  if(isAdd) {
                    return(
                      <Box sx={{ width: '180px' }}>
                      <InterviewTeamSelectBox
                      value={d}
                      manageSelect={(e:any) => {updateInterviewUsers(e, d)}}
                      />
                      </Box>
                    )
                  } else {
                    return <AvatarAndName 
                    avatarSize={18}
                    avatarName={`${d?.displayName}, ${d?.roleName ? d?.roleName : '-'}`} 
                    avatarImage={d?.avatarPath ? `${baseUrl}/Content${d?.avatarPath}` : ''}/>
                  }
                })
            }
            {
              !isAdd && interviewers && interviewers?.length > 3 &&
              <Typography className="mtbAuto ml10 fs13 fw800" sx={{ color: colors.blue.navy }} onClick={manageShowClick}>{showText}</Typography>
            }
          </Box>
          <Tooltip title={'Add Interview Team'} arrow placement="top">
            <FontAwesomeIcon className={'mtbAuto ml10 fs18 fw800 blackColor'}
             onClick={() => {
              const tempObj = {
                displayName: null,
                userId: null,
                id: null,
              };
              const tempArr:any = [...interviewers, tempObj];
              dispatch(setInterviewers(tempArr));
              setTempData(tempArr);
              setShowText('Show less');
              setIsAdd(true);
              }} icon={faPlus} />
          </Tooltip>
        </Box>
      </ClickAwayListener>
    )
}

export default DataPreview;